import React, { useEffect } from "react"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import StandardList from "../../../common/listing/list.component"
import { InventoryLocationAction } from "../../../state/inventory/location/actions"
import { InventoryLocationSelector } from "../../../state/inventory/location/selectors"
import { listingHeaders, mapToRows } from "../../../utils/inventory/utils"

export const Listing = injectIntl(() => {

    const dispatch = useDispatch()
    const inventoryLocations = useSelector(InventoryLocationSelector.getListing)

    useEffect(() => {
        dispatch(InventoryLocationAction.fetchListing())
    }, [])

    return (
        <StandardList
            className="row pt-3"
            headers={listingHeaders()}
            rows={inventoryLocations.map(loc => mapToRows(loc))}
        />
        
    )
})




// WEBPACK FOOTER //
// ./src/inventory/sections/location/Listing.tsx